import { backendFetch } from './apiUtils';

export const getRegistrationEoriAndCompany = async (searchTerm = '') => {
  const params = searchTerm ? { search: searchTerm.trim() } : {};
  return backendFetch({
    url: 'registration/eori',
    params,
    method: 'GET',
  });
};

export const getRegistrationSubmitters = async (searchTerm = '') => {
  const params = searchTerm ? { search: searchTerm.trim() } : {};
  return backendFetch({
    url: 'registration/submitter',
    params,
    method: 'GET',
  });
};

export const getRegistrationOriginators = async () => {
  return backendFetch({ url: 'registration/originator', method: 'GET' });
};

export const getRegistrationStatusList = async () => {
  return backendFetch({ url: 'registration/statusList', method: 'GET' });
};
